module.exports = __webpack_public_path__ + "img/s-cross-blanco-iridio.8ba384cc.png";